import { render, staticRenderFns } from "./myNewSelfSection.vue?vue&type=template&id=556eff14&scoped=true"
import script from "./myNewSelfSection.vue?vue&type=script&lang=js"
export * from "./myNewSelfSection.vue?vue&type=script&lang=js"
import style0 from "./myNewSelfSection.vue?vue&type=style&index=0&id=556eff14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556eff14",
  null
  
)

export default component.exports